/**
 * @typedef ProcessEnv
 * @property {string} REACT_APP_BACKEND_URL_DEV
 * @property {string} REACT_APP_BACKEND_URL_PROD
 * @property {string} REACT_APP_BACKEND_URL_LOCAL
 * @property {string} REACT_APP_BACKEND_WEBSOCKET_URL
 * @property {string} REACT_APP_BACKEND_WEBSOCKET_URL_LOCAL
 */
/**
 * @type {ProcessEnv}
 */
const env = process.env;

const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
const backendUrl = env.REACT_APP_HOSTING_URL || env.REACT_APP_BACKEND_URL_DEV;
const paymentManagementUrl = env.REACT_APP_PAYMENT_MANAGEMENT_URL;
const paymentManagementUrl_V2 = env.REACT_APP_PAYMENT_MANAGEMENT_URL_V2;

const memberManagementUrl = env.REACT_APP_MEMBER_MANAGEMENT_URL;
const emailManagementUrl = env.REACT_APP_EMAIL_MANAGEMENT_URL;
const STRIPE_PUBLIC_KEY = env.REACT_APP_STRIPE_PUBLIC_KEY;

const firebaseConfig = {
  apiKey: env.REACT_APP_GOOGLE_API_KEY,
  authDomain: env.REACT_APP_GOOGLE_AUTH_DOMAIN,
  projectId: env.REACT_APP_GOOGLE_PROJECT_ID,
  storageBucket: env.REACT_APP_GOOGLE_STORAGE_BUCKET,
  messagingSenderId: env.REACT_APP_GOOGLE_MESSAGING_SENDER_ID,
  appId: env.REACT_APP_GOOGLE_APP_ID,
};

export {
  isDev,
  STRIPE_PUBLIC_KEY,
  memberManagementUrl,
  paymentManagementUrl,
  paymentManagementUrl_V2,
  emailManagementUrl,
  backendUrl,
  env as envParams,
  firebaseConfig
};
